import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import type { ContractTemplateLock } from 'global-intern-types';
import {
  KONFLIKT_NEU_LADEN,
  KONFLIKT_TITEL,
  KONFLIKT_TROTZDEM,
  konfliktText,
  ZWEITES_FENSTER_NUR_LESEN,
  ZWEITES_FENSTER_TITEL,
  ZWEITES_FENSTER_WEITER,
  zweitesFensterFrageText,
} from '../../services/vorlagensperreTexte';

interface ZweitesFensterProps {
  halter: ContractTemplateLock | null;
  onNurLesen: () => void;
  onWeiter: () => void;
}

// RITA-1541, Entwurf v2 Bild 5: dieselbe Person hat die Vorlage schon in einem anderen Fenster offen.
export function ZweitesFensterDialog({ halter, onNurLesen, onWeiter }: ZweitesFensterProps) {
  return (
    <Dialog open={halter !== null} aria-labelledby="vertragsvorlage-zweites-fenster-titel">
      <DialogTitle id="vertragsvorlage-zweites-fenster-titel">{ZWEITES_FENSTER_TITEL}</DialogTitle>
      <DialogContent>
        <DialogContentText>{halter ? zweitesFensterFrageText(halter) : ''}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onNurLesen}>{ZWEITES_FENSTER_NUR_LESEN}</Button>
        <Button variant="contained" onClick={onWeiter}>
          {ZWEITES_FENSTER_WEITER}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface KonfliktProps {
  /** Zeitpunkt der fremden Speicherung (ISO) oder null, wenn kein Konflikt offen ist. */
  gespeichertUm: string | null;
  speichert: boolean;
  onNeuLaden: () => void;
  onTrotzdemSpeichern: () => void;
}

// RITA-1541, Entwurf v2 Bild 4 (Punkt B): „Neu laden“ ausgefüllt, „Trotzdem speichern“ mit Rahmen.
// Laut Ticket steht nur die Uhrzeit, keine Person. Das Fenster schließt nur über einen der Knöpfe.
export function SpeicherkonfliktDialog({ gespeichertUm, speichert, onNeuLaden, onTrotzdemSpeichern }: KonfliktProps) {
  return (
    <Dialog open={gespeichertUm !== null} aria-labelledby="vertragsvorlage-konflikt-titel">
      <DialogTitle id="vertragsvorlage-konflikt-titel">{KONFLIKT_TITEL}</DialogTitle>
      <DialogContent>
        <DialogContentText data-testid="vertragsvorlage-konflikt-text">
          {gespeichertUm ? konfliktText(gespeichertUm) : ''}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" disabled={speichert} onClick={onNeuLaden}>
          {KONFLIKT_NEU_LADEN}
        </Button>
        <Button variant="outlined" disabled={speichert} onClick={onTrotzdemSpeichern}>
          {speichert ? 'Wird gespeichert …' : KONFLIKT_TROTZDEM}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
